module.exports = __webpack_public_path__ + "img/cards@3x.2fe7c2d.png";